import React from "react";
import { useAccount } from "./useAccount";

const usePrimaryMember = () => {
  const { account } = useAccount();

  if (!account) return null;

  const { members } = account;

  const primaryMember = members.find((member) => member.type === "PRIMARY")!;

  return primaryMember;
};

export default usePrimaryMember;
